import { FormHelperText, styled } from "@mui/material";

export const HelperText = styled(FormHelperText)(({ theme }) => {
  return {
    ...theme.tokens.typography.text.standard,
    color: theme.tokens.colors.foreground.critical,
  };
});
